import type { ButtonProps } from "@components/core/Button";
import type React from "react";

import { Button, buttonVariants } from "@components/core/Button";

interface PlayPauseButtonProps extends ButtonProps {
  iconSize?: "md" | "sm";
  isPlaying: boolean;
  ref?: React.RefObject<HTMLButtonElement>;
}

function PlayIcon({ size }: { size: number }) {
  return (
    <svg viewBox='0 0 24 24' width={size} height={size} aria-hidden>
      <path
        fill='currentColor'
        d='M9.244 2.368C7.414 1.184 5 2.497 5 4.676v14.648c0 2.18 2.414 3.493 4.244 2.309l11.318-7.324c1.675-1.084 1.675-3.534 0-4.618z'
      />
    </svg>
  );
}

function PauseIcon({ size }: { size: number }) {
  return (
    <svg viewBox='0 0 24 24' width={size} height={size} aria-hidden>
      <path
        fill='currentColor'
        d='M6.75 3A2.75 2.75 0 0 0 4 5.75v12.5A2.75 2.75 0 0 0 6.75 21h.5A2.75 2.75 0 0 0 10 18.25V5.75A2.75 2.75 0 0 0 7.25 3z'
      />
      <path
        fill='currentColor'
        d='M16.75 3A2.75 2.75 0 0 0 14 5.75v12.5A2.75 2.75 0 0 0 16.75 21h.5A2.75 2.75 0 0 0 20 18.25V5.75A2.75 2.75 0 0 0 17.25 3z'
      />
    </svg>
  );
}

export const PlayPauseButton = ({
  isPlaying,
  ref,
  variant = "ghost",
  iconSize = "md",
  onClick,
  className,
  ...props
}: PlayPauseButtonProps) => {
  const size = iconSize === "sm" ? 16 : 20;
  const icon = isPlaying ? <PauseIcon size={size} /> : <PlayIcon size={size} />;
  const label = isPlaying ? "Pause" : "Play";
  return onClick ? (
    <Button
      aria-label={label}
      icon={icon}
      size='pill-sm'
      variant={variant}
      className={className}
      {...props}
      ref={ref}
      onClick={onClick}
    />
  ) : (
    <div className={buttonVariants({ variant, size: "pill-sm", className })}>{icon}</div>
  );
};
